module.exports = __webpack_public_path__ + "static/media/paris-150-01.9974ec45.jpg";